import { AbstractReportPmsApiService } from '../abstract-report.service';
import { RevenuePerAvailableRoom } from '../../../models/reports/production/revenue-per-available-room.model';

/**
 * @class RevenuePerAvailableRoomPmsApiService
 * @extends {AbstractReportPmsApiService<RevenuePerAvailableRoom>}
 */
export class RevenuePerAvailableRoomPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/production/revenue-per-available-room';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {RevenuePerAvailableRoom}
     * @protected
     */
    newModel(attributes, ...params) {

        return new RevenuePerAvailableRoom(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<RevenuePerAvailableRoom[]>}
     */
    getGraphData(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});

        return this.http
            .post(url, params, {
                headers: this.authHeaders,
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/production/revenue-per-available-room.service.js